import _ from 'lodash';
import messages from "../WizardPageHeader/WizardPageHeader.messages";
import TWIAJobHelper from 'ent-capability-quoteandbind-common-react/util/TWIAJobHelper';

const quoteExitPopup = async (event, path, translator, submission, showConfirm, beforeCancel) => {
    const confirmMessage = getConfirmMessage(submission, translator);
    event.preventDefault(); 
    showConfirm({
        title: messages.wizardCancelTitle,
        message: confirmMessage,
        status: 'warning',
        icon: 'mi-error-outline',
        confirmButtonText: messages.confirmButtonMsg,
        cancelButtonText: messages.cancelButtonMsg,
    }).then(async results => {
        if (results === 'cancel' || results === 'close') {
            return _.noop();
        }
        
        // DE15476 call an asynchronous function before exiting
        await beforeCancel();
        window.open(path, '_self');
                       
    }, _.noop);
};

// 2024-12-20 - Debra Frum - US29205 - PE - Renewal - Common - Cancel Quote Pop-up Message 
//                                          (Handles Commercial and Residential Both)
// Handle messages for Commercial Property in addition to Homeowners


// 2024-10-21 - Debra Frum - US29205 - PE - Residential Renewal - Common - Cancel Quote Pop-up Message
const getConfirmMessage = (submission, translator) => {
    const isTFPA = _.get(submission.value,'baseData.associationName_TWIA') === 'tfpa'
    const isCommercialProperty = _.get(submission.value, 'baseData.productCode') === 'CommercialProperty';
 
    const periodStatus = _.get(submission.value, 'baseData.periodStatus')
    const isStatusOfferSubmitted = periodStatus === 'Submitted_Ext';
 
    let confirmMessage = '';
    
    if (isStatusOfferSubmitted) {
        confirmMessage = '';

    } else if (TWIAJobHelper.isRenewal(submission.value)) {
        const policyNumber = _.get(submission.value, 'policyNumber');

        if (isCommercialProperty) {
                switch (periodStatus) {
            case 'Draft':
                confirmMessage = translator(messages.wizardDraftRenewalExitDescriptionCP, {policyNumber});
                break;
            case 'Quoted':
                confirmMessage = translator(messages.wizardQuotedRenewalExitDescriptionCP, {policyNumber});
                break;
            case 'Renewing':
                confirmMessage = translator(messages.wizardRenewingRenewalExitDescriptionCP, {policyNumber});
                break;
            default:
                break; 
            }

        // Homeowners
        } else {
            switch (periodStatus) {
                case 'Draft':
                    confirmMessage = translator(messages.wizardDraftRenewalExitDescriptionHO, {policyNumber});
                    break;
                case 'Quoted':
                    confirmMessage = translator(messages.wizardQuotedRenewalExitDescriptionHO, {policyNumber});
                    break;
                case 'Renewing':
                    confirmMessage = translator(messages.wizardRenewingRenewalExitDescriptionHO, {policyNumber});
                    break;
                default:
                    break; 
                }    
        }

    } else if (TWIAJobHelper.isPolicyChange(submission.value)) { // DE17804
        confirmMessage = messages.policyChangeCancelMessage

    } else {
        confirmMessage = messages.wizardQuoteCancelDescription;
    }

    return  confirmMessage;
};


export default {
    'quoteExitPopup': quoteExitPopup,
    'getConfirmMessage': getConfirmMessage
}
